'use strict';

/**
 * @ngdoc function
 * @name exhibitorPortalApp.controller:NavCtrl
 * @description
 * # NavCtrl
 * Controller of the exhibitorPortalApp
 */

(function (angular, window, undefined) {
  var NavCtrl = function ($state, $rootScope, $window, ShowService, ngCart, ActiveUserProfile, EnvironmentConfig, OrderService) {
    'ngInject'
    var self = this;

    self.root = $rootScope;


    $rootScope.hasDigitalBackpack = function () {
      if (
        !ShowService.data.currentShow ||
        !ShowService.data.currentShow.ShowCode ||
        !OrderService.data.orders ||
        !OrderService.data.orders[ShowService.data.currentShow.ShowCode]
      ) {
        return false;
      }

      const orders = OrderService.data.orders[ShowService.data.currentShow.ShowCode];
      const DIGITAL_BACKPACK_CODE = '802';

      for (var i = 0; i < orders.length; i++) {
        for (var a = 0; a < orders[i].Transactions.length; a++) {
          if (
            orders[i].Transactions[a].ProductCode === DIGITAL_BACKPACK_CODE &&
            orders[i].Transactions[a].TransTypeCode === 'PUR' &&
            orders[i].Transactions[a].TransStatus !== 'VOIDED'
          ) {
            return true;
          }
        }
      }
      return false;
    };

    self.hasDigitalBackpack = $rootScope.hasDigitalBackpack;

    self.inEvent = function () {
      return !!ShowService.data.currentShow;
    };

    self.openDigitalBackpack = function () {
      if (self.inEvent()) {
        ShowService.getDigitalBackpackLink({ showCode: ShowService.data.currentShow.ShowCode })
          .then(function () {
            const url = ShowService.data.digitalBackpackUrl;
            if (url && url.trim()) {
              // Track Digital Backpack click from Connect menu
              if (typeof dataLayer !== 'undefined') {
                dataLayer.push({ 
                  'event': 'GenericEvent', 
                  'eventCategory': 'Connect', 
                  'eventAction': 'Digital Backpack', 
                  'eventLabel': ShowService.data.currentShow.ShowCode 
                });
              }
              $window.open(url, '_blank');
            } else {
              console.error('Invalid or missing Digital Backpack URL');
            }
          })
          .catch(function (error) {
            console.error('Error fetching Digital Backpack URL:', error);
          });
      }
    };

    self.hasActivations = function () {
      return ShowService.data.currentShow && ShowService.data.activations && ShowService.data.activations[ShowService.data.currentShow.ShowCode];
    };

    self.hasCampaign = function () {
      if (ShowService.data.currentShow && ShowService.data.currentShow.ShowCode && OrderService.data.orders && OrderService.data.orders[ShowService.data.currentShow.ShowCode]) {
        var orders = OrderService.data.orders[ShowService.data.currentShow.ShowCode];

        for (var i = 0; i < orders.length; i++) {
          for (var a = 0; a < orders[i].Transactions.length; a++) {
            if (orders[i].Transactions[a].DataSalesListId && orders[i].Transactions[a].TransTypeCode === 'PUR' && orders[i].Transactions[a].TransStatus !== 'VOIDED')
              return true;
          }
        }
      }
    };

    self.hasCollateral = function () {
      if (ShowService.data.currentShow && ShowService.data.currentShow.ShowCode && OrderService.data.orders && OrderService.data.orders[ShowService.data.currentShow.ShowCode]) {
        var orders = OrderService.data.orders[ShowService.data.currentShow.ShowCode];
        var codes = ['311', '312', '313', '314']; //SWAP product codes

        for (var i = 0; i < orders.length; i++) {
          for (var a = 0; a < orders[i].Transactions.length; a++) {
            if (codes.indexOf(orders[i].Transactions[a].ProductCode) > -1 && orders[i].Transactions[a].TransTypeCode === 'PUR' && orders[i].Transactions[a].TransStatus !== 'VOIDED')
              return true;
          }
        }
      }
    };

    self.shop = function () {
      $state.go('event.shop.products');
    };

    self.logout = function () {
      //Added broadcast to prevent exit without saving survey's changes
      const eventLogout = $rootScope.$broadcast('beforeLeave');
      if (eventLogout.defaultPrevented) return;
      window.location = EnvironmentConfig.SiteRoot + 'home/logout' + (ActiveUserProfile.SWAPOnly ? '/?swap=true' : '');
    };
  };

  angular.module('exhibitorPortalApp')
    .controller('NavCtrl', NavCtrl);
})(angular, window);
